import * as React from "react";
import { forwardRef, useImperativeHandle, useState } from "react";
import FormInput from "./FormInput";
import InputProps from "../../../model/form/InputProps";
import { buildClasses } from "../../../utils/classes";
import Option from "../../../model/Option";
import "./SelectInput.scss";
import InputState from "../../../model/form/InputState";

interface GroupSelectInputProps extends InputProps {
  topOptions: Option[];
  groupOptions: Map<string, Option[]>;
}

const GroupSelectInput = forwardRef((props: GroupSelectInputProps, ref) => {
  const [value, setValue] = useState(props.initialValue);

  useImperativeHandle(ref, () => ({
    reset: (value?: any) => {
      setValue(value ? value : props.initialValue);
    },
  }));

  const template = (state: InputState, input: any) => (
    <div
      className={buildClasses(
        {
          [props.additionalClass]: () => !!props.additionalClass,
          invalid: () => state.status.invalid && !state.status.pristine,
        },
        "input-group"
      )}
    >
      {(props.label || props.detail) && (
        <label htmlFor={props.name}>
          <span>{props.label}</span>
          <span className="detail">{props.detail}</span>
        </label>
      )}
      <div className="group">
        <select
          name={props.name}
          id={props.name}
          onChange={(e) => {
            setValue(e.target.value);
            input.change(e);
          }}
          onBlur={input.dirty}
          value={value}
          disabled={props.disabled}
        >
          {props.placeholder && (
            <option key="select-input-placeholder" value={""} hidden>
              {props.placeholder}
            </option>
          )}

          {props.topOptions.sort(Option.byName).map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
          {Array.from(props.groupOptions).map(([name, options]) => (
            <optgroup label={name} key={name}>
              {options.sort(Option.byName).map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
        <div className="h-flex centered valid point-through">
          <i className="ic_chevron_down" />
        </div>
      </div>
      <div className="error-message">{state.status.errorMessage}</div>
    </div>
  );

  return <FormInput {...props} template={template} />;
});

export default GroupSelectInput;
